import { CurrencyType } from '@/api/Wallet/Types/Wallet'
import { AuditLog } from 'api/Clients/Types/AuditLog'
import { ExchangeRate } from 'api/Clients/Types/ExchangeRate'
import { CreateRateMarkup } from 'api/Exchange-Rates/CreateRateMarkup'
import { RateMarkupDto } from 'api/Exchange-Rates/RateMarkupDto'
import { UpdateCurrencyRates, UpdateRateMarkup } from 'api/Exchange-Rates/UpdateRateMarkup'
import { PageData } from 'api/Pagination/Types'

import { ApiClient } from './ApiClient'
import { PageQuery, preparePageQueryParams } from './index'

export class ExchangeRatesApiClient {
  constructor(private apiClient: ApiClient) {}
  fetchRateMarkups: (query?: PageQuery) => Promise<PageData<RateMarkupDto[]>> = (query) => {
    return this.apiClient.get(`exchange-rates/currency-markups?${preparePageQueryParams(query)}`)
  }
  fetchRateMarkupsAllForCurrency: (
    quoteCurrencyId: string,
    queryParams?: string
  ) => Promise<ExchangeRate[]> = (quoteCurrencyId, queryParams) => {
    const query = queryParams ? `?${queryParams}` : ''
    return this.apiClient.get(
      `exchange-rates/currency-markups/all-for-currency/${quoteCurrencyId}${query}`
    )
  }

  addRateMarkup: (data: CreateRateMarkup) => Promise<void> = (data) => {
    return this.apiClient.post(`exchange-rates/currency-markups`, data)
  }
  updateRateMarkup: (id: string, data: UpdateRateMarkup) => Promise<void> = (id, data) => {
    return this.apiClient.put(`exchange-rates/currency-markups/${id}`, data)
  }
  updateCurrencyRates: (quoteCurrency: string, data: UpdateCurrencyRates) => Promise<void> = (
    quoteCurrency,
    data
  ) => {
    return this.apiClient.put(
      `exchange-rates/currency-markups/update-currency-rates/${quoteCurrency}`,
      data
    )
  }
  deleteRateMarkup: (id: string) => Promise<void> = (id) => {
    return this.apiClient.delete(`exchange-rates/currency-markups/${id}`)
  }
  getLatestExchangeRate: (
    QuoteCcy: CurrencyType,
    BaseCcy: CurrencyType,
    direction: 'sell' | 'buy' | null,
    baseWalletTypeId?: number,
    quoteWalletTypeId?: number
  ) => Promise<ExchangeRate> = (
    QuoteCcy,
    BaseCcy,
    direction = null,
    baseWalletTypeId,
    quoteWalletTypeId
  ) => {
    let url = `exchange-rates/exchange-rates/latest?QuoteCcy=${QuoteCcy}&BaseCcy=${BaseCcy}`
    if (direction) {
      url += `&direction=${direction}`
    }
    if (baseWalletTypeId) {
      url += `&BaseWalletTypeId=${baseWalletTypeId}`
    }
    if (quoteWalletTypeId) {
      url += `&QuoteWalletTypeId=${quoteWalletTypeId}`
    }
    url += `&pageSize=10&pageIndex=1`

    return this.apiClient.get(url)
  }
  getExchangeRatesQuery: (query?: PageQuery, date?: string) => Promise<ExchangeRate[]> = (
    query,
    date
  ) => {
    let url
    if (date) {
      url = `exchange-rates/exchange-rates/daily/${date}/all?${preparePageQueryParams(query)}`
    } else {
      url = `exchange-rates/exchange-rates/latest/all?${preparePageQueryParams(query)}`
    }
    return this.apiClient.get(url)
  }

  getExchangeRateData: () => Promise<AuditLog[]> = () => {
    return this.apiClient.get(`exchange-rates/exchange-rates/currency-markups/events`)
  }
}
